module.exports = __webpack_public_path__ + "74e55ba5d34e3c61d8ea789e4bb635ec.svg";